import { fork, take } from 'redux-saga/effects';

export default function* takeLeading(pattern, saga, ...args) {
  let lastTask = null;
  while (true) {
    const action = yield take(pattern);
    if (!lastTask || !lastTask.isRunning()) {
      lastTask = yield fork(saga, ...args.concat(action));
    }
  }
}
